import { styled } from "@material-ui/core";

/** Resting height of the bar (it never wraps — it scrolls horizontally). */
export const ACTION_BAR_MIN_HEIGHT = 64;

// Shared shell for a bottom action bar: a strip pinned to the bottom of the
// viewport that scrolls horizontally rather than wrapping its buttons. Exported
// on its own as an escape hatch so callers with bespoke contents (e.g. the
// price-list edit/review modes) reuse the exact positioning without going
// through the config-driven <ActionBar>.
//
// It's `position: fixed`, so a page must render an <ActionBarSpacer /> at the
// end of its scrollable content to keep that content above the bar.
export const ActionBarContainer = styled("nav")(({ theme }) => ({
  position: "fixed",
  minHeight: `${ACTION_BAR_MIN_HEIGHT}px`,
  zIndex: theme.zIndex.drawer + 1,
  width: "100%",
  maxWidth: "100vw",
  right: 0,
  bottom: 0,
  left: 0,
  overflow: "auto",
  whiteSpace: "nowrap",
  backgroundColor: theme.palette.background.paper,
  padding: "4px 18px",
  boxShadow: "0px -3px 6px 0px lightgrey",
  display: "inline-flex",
  gap: theme.spacing(1),
  alignItems: "center",
}));
